import { useEffect } from 'react'
import { array, bool, func, object, string, node } from 'prop-types'
import CopyToClipboard from 'react-copy-to-clipboard'
import { MenuLink, MenuLinks, SubMenuHeader } from '../styled-components'
import OutsideClickWrapper from '../../../utils/OutsideClickWrapper'
import FeatureAvailability from '../../../containers/FeatureAvailability'
import FeatureBadge from '../../../containers/FeatureAvailability/components/FeatureBadge'
import SubMenuProjectSettingsItem from './submenu-project-settings-item'

const SubmenuNewItems = ({
  items,
  style,
  toggleSubmenu,
  setOpen,
  type,
  show: visible,
  setOnMouseLeave,
  parentRef,
  children
}) => {
  const toggleShow = (show) => {
    setOpen(show)
  }

  const handleClickOutside = (e) => {
    if (!parentRef.current?.contains(e.target)) toggleShow(false)
  }

  const getMenuItem = (menuItem, index) => {
    if (menuItem.hide) return null
    const menuItemProps = { ...menuItem }
    delete menuItemProps.hide
    const asDisabled = menuItem.disabled ? 'button' : menuItem.as

    if (menuItem.header) {
      return (
        <SubMenuHeader key={menuItem.label} onClick={menuItem.onClick}>
          {menuItem.label}
        </SubMenuHeader>
      )
    }

    const onClickToggle = (e) => {
      toggleSubmenu(e)
      menuItem.onClick()
    }

    const itemProps = {
      ...menuItemProps,
      as: asDisabled,
      hide: (!!menuItem.hide).toString(),
      onClick: onClickToggle,
      textalignment: style?.textAlignment
    }

    if (menuItem.isProjectSettings) {
      return (
        <SubMenuProjectSettingsItem
          key={menuItem.label}
          menuItem={menuItem}
          itemProps={itemProps}
        />
      )
    }

    const item = menuItem.to ? (
      <MenuLink {...itemProps} key={menuItem.label}>
        {menuItem.icon ?? ''}
        {menuItem.label}
      </MenuLink>
    ) : (
      <FeatureAvailability
        key={menuItem.label}
        featureSlug={menuItem.featureSlug}
        featureSection={menuItem.featureSection}
        render={({ isDisabled, requiredTier, loading, error }) => (
          <MenuLinks {...itemProps}>
            {menuItem.icon ?? ''}
            {menuItem.label}
            {isDisabled() && (
              <FeatureBadge
                tier={requiredTier}
                loading={loading}
                error={error}
              />
            )}
          </MenuLinks>
        )}
      />
    )

    if (menuItem.onCopy) {
      return (
        <CopyToClipboard
          onCopy={menuItem.onCopy}
          text={
            menuItem.text ||
            `${window.location.protocol}//${window.location.host}${window.location.pathname}`
          }
          key={menuItem.text || index}
          data-testid={menuItem.testId}
        >
          {type === 'block' ? (
            item
          ) : (
            <li data-testid={menuItem.testId}>{item}</li>
          )}
        </CopyToClipboard>
      )
    }

    return type === 'block' ? (
      item
    ) : (
      <li key={index} data-testid={menuItem.testId}>
        {item}
      </li>
    )
  }

  useEffect(() => {
    setOpen(true)
  }, [])

  useEffect(() => {
    if (setOnMouseLeave) toggleShow(false)
  }, [setOnMouseLeave])

  const content = items?.map(getMenuItem)

  return (
    <OutsideClickWrapper
      onCloseIntent={handleClickOutside}
      style={{ display: 'inherit' }}
      active={visible}
    >
      {visible && content && <ul>{content}</ul>}
      {visible && children && <ul>{children}</ul>}
    </OutsideClickWrapper>
  )
}

SubmenuNewItems.propTypes = {
  items: array,
  style: object,
  toggleSubmenu: func,
  setOpen: func,
  type: string,
  setOnMouseLeave: bool,
  show: bool,
  parentRef: object,
  children: node
}

export default SubmenuNewItems
